import { render, staticRenderFns } from "./DeliveryDates.vue?vue&type=template&id=1fe7c2b8&lang=pug&"
import script from "./DeliveryDates.vue?vue&type=script&lang=js&"
export * from "./DeliveryDates.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryDates.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports